import {
  DbuiV1TablePreviewData,
  dbuiV1TablePreviewOptions,
} from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';
import { defaultOptions } from '@/utils/query';

type TablePreviewOptions = Omit<
  DbuiV1TablePreviewData['query'],
  'warehouse'
> & { disabled?: boolean };

export const useGetTablePreview = (options: TablePreviewOptions) => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  return useQuery({
    ...dbuiV1TablePreviewOptions({
      ...defaultOptions(),
      path: { workspace: workspace! },
      query: {
        warehouse: selectedWarehouse?.id || '',
        ...options,
      },
    }),
    enabled:
      !!workspace && !!selectedWarehouse && !!options.name && !options.disabled,
  });
};
